import { ArrowLeftRight, ChevronLeft, HelpCircle, Pencil } from "lucide-react";

import { Badge } from "@/components/badge";
import { Button } from "@/components/button";

type MBCChatHeaderProps = {
  isTeamMember?: boolean;
  onBack?: () => void;
  onSwitchToClassic?: () => void;
  requestName?: string;
};

export function MBCChatHeader({
  isTeamMember = false,
  onBack,
  onSwitchToClassic,
  requestName = "Request name",
}: MBCChatHeaderProps) {
  return (
    <header className="flex items-center justify-between gap-lg border-b border-border-secondary bg-bg-primary px-3xl py-lg">
      <div className="flex min-w-0 items-center gap-md">
        <button
          aria-label="Go back"
          className="flex size-9 shrink-0 items-center justify-center rounded-lg border border-border-primary text-text-secondary outline-hidden transition-colors hover:bg-bg-primary-hover"
          onClick={onBack}
          type="button"
        >
          <ChevronLeft className="size-5" />
        </button>
        <h1 className="truncate text-lg font-semibold text-text-primary">
          {requestName}
        </h1>
        <button
          aria-label="Edit request name"
          className="text-fg-quinary transition-colors hover:text-text-secondary"
          type="button"
        >
          <Pencil className="size-4" />
        </button>
        <Badge size="small" variant="brand">
          Graphic
        </Badge>
      </div>

      <div className="flex items-center gap-lg">
        <span className="flex items-center gap-1.5 text-sm text-text-tertiary">
          <HelpCircle className="size-4" />
          AI usage
        </span>
        {isTeamMember && onSwitchToClassic ? (
          <Button onPress={onSwitchToClassic} size="sm" variant="secondary">
            <ArrowLeftRight className="size-4" />
            Switch to Classic Brief Form
          </Button>
        ) : null}
      </div>
    </header>
  );
}
